import React from "react";

const CustomBetInsights = (props) => {
  const { data, context, showTotalButton, showUsersButton,showAmount } = props;
  
  const { handleTotalBets, handleUniqueUsers } = context;

  return (
  <div className="flex flex-col items-center justify-center w-full h-full space-y-2">
  {showTotalButton && (
    <button
      className="bg-blue-400 hover:bg-green-600 text-white py-2 rounded text-sm min-w-[80px]"
      onClick={() => handleTotalBets(data)}
      title="Show total bets"
    >
      {data.total_bets_on_digit}
    </button>
  )}
  {showUsersButton && (
    <button
      className="bg-yellow-500 hover:bg-purple-600 text-white px-4 py-2 rounded text-sm min-w-[80px]"
      onClick={() => handleUniqueUsers(data)}
      title="Show unique users"
    >
      {data.unique_users_on_digit}
    </button>
  )}
  {showAmount && (
    <div className="text-green-500 font-bold text-sm">
      {parseFloat(data.total_stake_on_digit || 0).toFixed(2)}
    </div>
  )}
</div>
  );
};

export default CustomBetInsights;
